/**
 * 从组织机构树中获取人员
 * @param {array} list 递归的组织机构数组
 *
 * @returns {array} 归集用户数组
 */
export function loopUserList(list) {
  let user = []
  list.forEach(d => {
    if (d.orglist.length > 0)
      user = user.concat(loopUserList(d.orglist))
    if (d.userlist.length > 0)
      user = user.concat(d.userlist.map(o => ({
        id: o.orgoruserid,
        name: o.orgorusername,
        group: d.orgorusername
      })))
  });
  return user
}

export function loopMenuList(list, parent) {
  const res = []
  list.forEach(d => {
    if (d.parentmenucode === parent) {
      const o = {key: d.menucode, title: d.menuname}
      const childs = loopMenuList(list, d.menucode)
      if (childs.length > 0)
        o.children = childs
      o.data = d
      res.push(o)
    }
  })
  return res
}

/**
 * json数组组装树层级机构
 * @param list      json数组
 * @param parent    顶级parent
 * @param param    <pre> {
                      idFiled: id标识
                      ,nameField: name标识
                      ,parentField: 上级标识
                    }
 </pre>
 * @returns {Array}
 */
export function loopTreeData(data,parent, param){ // 删除 所有 children,以防止多次调用
  const jparam = Object.assign({
    idFiled: 'id'
    , nameField: 'name'
    , parentField: 'pid'
  }, param)
  data.forEach(function(item) {
    delete item.children;
  }); // 将数据存储为 以 id 为 KEY 的 map 索引数据列
  let map = {};
  data.forEach(function(item) {
    item.isLeaf = true;
    map[item[jparam.idFiled]] = item;
  }); //        console.log(map);
  let val = [];
  data.forEach(function(item) { // 以当前遍历项，的pid,去map对象中找到索引的id
    item.key = item[jparam.idFiled];
    item.value = item[jparam.idFiled];
    item.title = item[jparam.nameField];
    item.data = item;
    var parent = map[item[jparam.parentField]]; // 好绕啊，如果找到索引，那么说明此项不在顶级当中,那么需要把此项添加到，他对应的父级中
    if(parent) {
      parent.isLeaf = false;
      (parent.children || (parent.children = [])).push(item);
    } else { //如果没有在map中找到对应的索引ID,那么直接把 当前的item添加到 val结果集中，作为顶级
      item.isLeaf = false;
      val.push(item);
    }
  });
  map = {};
  return val;
}

export function loopTreeData2(list, parent, param) {
  if(parent =="" || parent == undefined){
    const jparam = Object.assign({
      idFiled: 'id'
      , nameField: 'name'
      , parentField: 'pid'
    }, param)
    const result = []
    if (!Array.isArray(list)) {
      return result
    }
    list.forEach(item => {
      delete item.children
    })
    const map = {}
    list.forEach(item => {
      map[item[jparam.idFiled]] = item
    })
    list.forEach(item => {
      const parent = map[item[jparam.parentField]]
      item.key = item[jparam.idFiled]
      item.value = item[jparam.idFiled]
      item.title = item[jparam.nameField]
      item.data = item
      if (parent) {
        (parent.children || (parent.children = [])).push(item)
      } else {
        result.push(item)
      }
    })
    return result
  }
  const res = []
  const jparam = Object.assign({
    idFiled: 'id'
    , nameField: 'name'
    , parentField: 'pid'
  }, param)
  list.forEach(d => {
    if (d[jparam.parentField].trim() === parent.trim()) {
      const o = {
        key: d[jparam.idFiled]
        , value: d[jparam.idFiled]
        , title: d[jparam.nameField]
        , data: d
      }
      const childs = loopTreeData(list, d[jparam.idFiled], param)
      if (childs.length > 0) {
        o.children = childs
        o.isLeaf = false
      } else {
        o.isLeaf = true
      }
      o.data = d
      res.push(o)
    }
  })
  return res
}

/**
 * 获取树结构的每一个第一个叶子节点
 * 例如每个部门第一个员工
 * @param tree
 */
export function getTreeFirstNode(tree){
  let temp = []
  let forFn = function (arr) {
    if (arr && arr.length > 0) {
      arr.map(o=>{
        if (o.children) {
          let leafList = o.children.filter(co=>co.isLeaf === true)
          if (leafList.length > 0) {
            temp.push(leafList[0])
          }
          forFn(o.children);
        }
      })
    }
  }
  forFn(tree)
  return temp
}
